import { tdsFetch } from '@/utils/fetch';

const sysPrefix = '/system';

export const loginApi = (data) => tdsFetch(sysPrefix + '/sys/login', { method: 'POST', body: data, ignoreToken: true, joinPrefix: false })

export const getUserInfo = () => tdsFetch(sysPrefix + '/sys/user/getUserInfo', { method: 'GET', joinPrefix: false })

export const getUserPermission = () => tdsFetch(sysPrefix + '/sys/permission/getUserPermissionByToken', { method: 'GET', joinPrefix: false })

// raw: true —— 返回完整响应体（含 success / message），便于把注册失败原因显示给用户
export const registerApi = (data) => tdsFetch(sysPrefix + '/sys/user/register2', { method: 'POST', body: data, ignoreToken: true, joinPrefix: false, raw: true })

export function updateUserInfo(data) {
  return tdsFetch(sysPrefix + '/sys/user/login/setting/userEdit2', {
    method: 'POST',
    body: data,
    joinPrefix: false 
  })
}

export function updatePassword(data) {
  return tdsFetch(sysPrefix + '/sys/user/changePassword2', {
    method: 'PUT',
    body: data,
    joinPrefix: false 
  })
}

export const sendSms = (data) => {
  return tdsFetch(sysPrefix + '/sys/sms/send', {
    method: 'POST',
    body: data,
    joinPrefix: false,
    ignoreToken: true
  })
}

//权限验证接口
export const fetchAuth = (data) => {
  return tdsFetch(sysPrefix + '/login/check', { 
    method: 'POST', 
    body: data, 
    joinPrefix: false 
  })
}